export function sortAction() {
  const sortArea = document.querySelector('.js-sort'); // ソート対象のエリアを取得
  const searchInput = document.querySelector('.js-searchInput'); // 検索入力欄を取得

  // ソートエリアが存在しない場合は処理を終了
  if (!sortArea) {
    return false;
  }

  const sortTrigger = sortArea.querySelectorAll('.js-toggleActive'); // ソートボタン群を取得
  const sortItem = sortArea.querySelectorAll('.js-sortItem'); // ソート対象アイテム群を取得
  const all = sortArea.querySelector('.js-toggleActive[data-value="all"]'); // 「すべて」ボタンを取得

  let selectValues = []; // 選択された値を保持する配列

  /**
   * ソートアイテムの表示・非表示を切り替える関数
   * @param {Array} array - 選択されたクラス名の配列
   */
  const sortToggle = (array) => {
    sortItem.forEach((item) => {
      // アイテムが選択されたクラス名を持つ場合は表示、それ以外は非表示
      const value = array.some((className) => item.classList.contains(className));
      item.style.display = value ? 'block' : 'none';
    });
  };

  /**
   * ソートボタンの状態を切り替える関数
   * @param {HTMLElement} el - 対象のソートボタン要素
   * @param {boolean} boolean - アクティブ状態にするかどうか
   */
  const sortBtnToggle = (el, boolean) => {
    const value = el.dataset.value;

    if (boolean) {
      all.classList.remove('is-active'); // 「すべて」ボタンのアクティブ状態を解除
      el.classList.add('is-active'); // 対象ボタンをアクティブ状態に設定
      selectValues.push(value); // 選択値を追加
    } else {
      el.classList.remove('is-active'); // 対象ボタンのアクティブ状態を解除
      selectValues = selectValues.filter((x) => x !== value); // 選択値から削除
    }

    sortToggle(selectValues); // アイテム表示・非表示を更新
  };

  /**
   * 「すべて」ボタンがクリックされた際の処理
   * @param {HTMLElement} el - 「すべて」ボタン要素
   */
  const selectAll = (el) => {
    selectValues = []; // 選択値をリセット
    sortTrigger.forEach((trigger) => {
      trigger.classList.remove('is-active'); // 全てのソートボタンのアクティブ状態を解除
    });

    el.classList.add('is-active'); // 「すべて」ボタンをアクティブ状態に設定

    sortItem.forEach((item) => {
      item.style.display = 'block'; // 全てのアイテムを表示
    });
  };

  /**
   * ソートトリガー（フィルタボタン）のクリック処理
   */
  sortTrigger.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const value = this.dataset.value;

      // 検索入力欄のテキストをクリア（フィルタ操作時に検索状態をリセット）
      if (searchInput) {
        searchInput.value = '';
      }

      if (value === 'all') {
        selectAll(this); // 「すべて」ボタンがクリックされた場合の処理
      } else {
        if (this.classList.contains('is-active')) {
          sortBtnToggle(this, false); // アクティブ状態解除処理
        } else {
          sortBtnToggle(this, true); // アクティブ状態設定処理
        }
      }
    });
  });

  /**
   * キーワードで絞り込み
   */
  if (document.querySelector('.js-searchBtn')) {
    const searchBtnEle = document.querySelector('.js-searchBtn');

    searchBtnEle.addEventListener('click', () => {
      // アクティブなソートトリガーのリセット（検索時にフィルタ状態をリセット）
      sortTrigger.forEach((trigger) => {
        trigger.classList.remove('is-active');
      });
      all.classList.remove('is-active'); // 「すべて」ボタンのアクティブ状態も解除
      selectValues = []; // 選択値もリセット

      // 検索処理：入力されたキーワードでアイテムを絞り込み表示・非表示を切り替え
      const searchText = searchInput.value.toLowerCase(); // 検索キーワード（小文字化）
      const sortItems = sortArea.querySelectorAll('.js-sortItem');

      sortItems.forEach((item) => {
        const itemText = item.textContent.toLowerCase(); // アイテム内テキスト（小文字化）
        item.style.display = itemText.includes(searchText) ? 'block' : 'none'; // 部分一致で表示・非表示切り替え
      });
    });
  }
}
